// React
import React from 'react';
// External
import {
    Image, Row, Col
} from 'react-bootstrap';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import HeaderDivider from 'components/shared/atoms/HeaderDivider/HeaderDivider';
import GUIDANCE_MATERIAL from 'constants/guidanceMaterialLinks';
// import { isLawnswoodBrand } from 'services/users';
// import BrandService from 'services/brand';
import VetService from 'services/vet';
// Style
import './styles.scss';
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';

const BUSINESS_CENTER_EXCLUSION = ['Patch & Purr'];

class CustomerSupport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            teamRepresentative: null,
            clientCare: null,
            brandName: '',
            brandData: {},
        };

        this.phoneFormats = {
            clientCare: [2, 4, 4],
            teamRepresentative: [4, 3, 3],
        };

        this.getVetDetails();
        this.getTeamRepresentative();

        this.guidanceMaterial = [];
    }

    getContactClientCare() {
        const vetData = JSON.parse(localStorage.getItem('vet'));

        if (vetData && vetData.class_new_brand && vetData.business_center) {
            const { class_new_brand, business_center } = vetData;
            const brandName = class_new_brand.name || "";
            const brandEmail = class_new_brand.cstm.brand_email_c || "";

            this.setState({
                clientCare: {
                    name: `${class_new_brand.name} Client Care`,
                    email: <a href={`mailto:${BUSINESS_CENTER_EXCLUSION.includes(brandName) ? brandEmail : business_center.cstm.email_c}`}>{BUSINESS_CENTER_EXCLUSION.includes(brandName) ? brandEmail : business_center.cstm.email_c}</a> ?? '',
                    officePhone: business_center.cstm.phone_number_1_c ?? business_center.cstm.phone_number_2_c ?? '',
                }
            });
        }
        // BrandService.getBrand(this.state.brandName)
        //     .then((response) => {
        //         if (response.data) {
        //             this.setState({
        //                 clientCare: {
        //                     name: response.data.name + ' Client Care',
        //                     email: <a href={`mailto:${response.data.cstm.brand_email_c}`}>{response.data.cstm.brand_email_c}</a> ?? '',
        //                     officePhone: response.data.phone_work,
        //                 }
        //             });
        //         }
        //     }).catch((err) => {
        //         console.error(err);
        //     });
    }

    getTeamRepresentative() {
        VetService.getTeamRepresentative()
            .then((response) => {
                if (response.data && response.data.email_addresses.length) {
                    this.setState({
                        teamRepresentative: response.data
                    });
                }
            }).catch((err) => {
                console.error(err);
            });
    }

    getFullName() {
        return `${this.state.teamRepresentative.first_name} ${this.state.teamRepresentative.last_name}`;
    }

    /**
     * Get phone number hyperlink
     * 
     * @param {String} strPhone
     * @param {Array} strPhone  
     * 
     * @returns
     */
    getPhoneHyperlink(strPhone, arFormat) {
        // Stop if the team representative/assigned user has no mobile phone
        if (!strPhone) {
            return;
        }

        const phoneMobileArr = [];

        if (strPhone.startsWith('+')) {
            strPhone = strPhone.replace('+61', '0');
        }

        phoneMobileArr.push(strPhone.substring(0, arFormat[0]));
        phoneMobileArr.push(strPhone.substring(arFormat[0], arFormat[0] + arFormat[1]));
        phoneMobileArr.push(strPhone.substring(arFormat[0] + arFormat[1]));

        strPhone = phoneMobileArr.join('-');

        return <a href={`tel:${phoneMobileArr.join('-')}`}>{phoneMobileArr.join(' ')}</a>;
    }

    /**
     * Extract parent brand name
     * 
     * @param {String} strParentBrand 
     * 
     * @returns {String}
     */
    getParentBrandName = (strParentBrand) => {
        if (strParentBrand.includes('Lawnswood')) {
            return 'Lawnswood';
        }

        if (strParentBrand.includes('Edenhills')) {
            return 'Edenhills';
        }
        
        if (strParentBrand.includes('Patch and Purr')) {
            return 'Patch and Purr';
        }

        if (strParentBrand.includes('Pets in Peace')) {
            return 'Pets in Peace';
        }

        return '';
    }

    getEmail = (data) => {
        if (data && data.email_addresses && data.email_addresses.length) {
            return <a href={`mailto:${data.email_addresses[0].email_address}`}>{data.email_addresses[0].email_address}</a>;
        }
        return null;
    }

    /**
     * Retrieves the brand data based on the brand name.
     * @param {string} businessEmail - The business center email.
     * @param {string} brandName - The brand name.
     * @returns {Object} - An object containing the bucketListUrl and griefGuidanceUrl.
     */
    getBusinessCenterData(businessEmail, brandName = "") {
        if (!businessEmail) {
            const vetData = JSON.parse(localStorage.getItem('vet'));

            if (vetData && vetData.business_center && vetData.business_center.cstm && vetData.business_center.cstm.email_c) {
                businessEmail = vetData.business_center.cstm.email_c;
            }
        }

        businessEmail = businessEmail || "";

        if (businessEmail.includes('care@lawnswood.com.au')) {
            return {
                bucketListUrl: GUIDANCE_MATERIAL.lawnswood.bucketList,
                griefGuidanceUrl: GUIDANCE_MATERIAL.lawnswood.griefGuidance,
            };
        }

        if (businessEmail.includes("country@edenhills.com.au")) {
            return {
                griefGuidanceUrl: GUIDANCE_MATERIAL.edenhills.griefGuidance.AW,
                bucketListUrl: GUIDANCE_MATERIAL.edenhills.bucketList
            }
        }

        if (businessEmail.includes("care@edenhills.com.au")) {
            return {
                griefGuidanceUrl: GUIDANCE_MATERIAL.edenhills.griefGuidance.VIC,
                bucketListUrl: GUIDANCE_MATERIAL.edenhills.bucketList
            }
        }

        if (businessEmail.includes("support@edenhills.com.au")) {
            return {
                griefGuidanceUrl: GUIDANCE_MATERIAL.edenhills.griefGuidance.SA,
                bucketListUrl: GUIDANCE_MATERIAL.edenhills.bucketList
            }
        }

        //QLD PiP
        if (businessEmail.includes('care@petsinpeace.com.au')) {
            return {
                bucketListUrl: GUIDANCE_MATERIAL.qld.bucketList,
                griefGuidanceUrl: GUIDANCE_MATERIAL.qld.griefGuidance,
            };
        }

        // NSW CW
        if (brandName === "Pets at Peace CW") {
            return {
                griefGuidanceUrl: GUIDANCE_MATERIAL.nsw.griefGuidance.CW,
                bucketListUrl: GUIDANCE_MATERIAL.nsw.bucketList.CW
            }
        }

        // both NSW SW & MO same 
        if (brandName === "Patch & Purr") {
            return {
                griefGuidanceUrl: GUIDANCE_MATERIAL.nsw.griefGuidance.MO,
                bucketListUrl: GUIDANCE_MATERIAL.nsw.bucketList.MO
            }
        }

        return {
            griefGuidanceUrl: "",
            bucketListUrl: ""
        }
    }

    /**
     * Get the guidance material data
     */
    getGuidanceMaterials(businessEmail, brandName = "") {
        const { bucketListUrl, griefGuidanceUrl } = this.getBusinessCenterData(businessEmail, brandName);
        
        this.guidanceMaterial = [
            [
                'Pet Bucket List',
                'PDF',
                'Creating a Bucket List is a great way to honour your friendship before your pet passes',
                <a
                    href={bucketListUrl}
                    target="_blank"
                    className="guidance-link"
                    rel="noopener noreferrer"
                >
                    View
                </a>
            ],
            [
                'Pet Loss and Grief Brochure',
                'PDF',
                'Support for you and your family',
                <a
                    href={griefGuidanceUrl}
                    target="_blank"
                    className="guidance-link"
                    rel="noopener noreferrer"
                >
                    View
                </a>
            ]
        ];
    }

    /**
     * Get Vet Detail
     */
     getVetDetails() {
        VetService.getVetDetails()
            .then((response) => {
                this.setState({ brandName: response.data.class_new_brand.name }, () => {
                    this.getGuidanceMaterials(String(response.data.business_center.cstm.email_c).toLowerCase(), String(response.data.class_new_brand.name || ""));
                    this.getContactClientCare();
                });
            }).catch((err) => {
                console.error(err);
            });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="Customer support" />
                    <ContentCard
                        className="mt-62 tagging-content-card pb-4"
                        divider={false}
                        headerBtnText="View more"
                    >
                        <div className="help-container">
                            <HeaderDivider title="Client Care Team" className="help-header pt-4" />
                            <p className="">
                                You can contact our client care team for support with bookings and client queries.
                            </p>
                            <Row>
                                {
                                    this.state.clientCare
                                        ? (
                                            <Col className="col pl-4" md="12" lg="12">
                                                <p>{this.state.clientCare.name}</p>
                                                <p>{this.getPhoneHyperlink(this.state.clientCare.officePhone, this.phoneFormats.clientCare)}</p>
                                                <p>{this.state.clientCare.email}</p>
                                            </Col>
                                        ) : null
                                }
                            </Row>
                            <HeaderDivider title="Relationship Manager" className="help-header pt-4" />
                            <p className="">
                                You can contact your local relationship manager with support queries and feedback, or to request an on-site visit.
                            </p>
                            <Row>
                                {
                                    this.state.teamRepresentative?.picture?.src
                                        ? (
                                            <Col>
                                                <Image
                                                    src={this.state.teamRepresentative.picture.src}
                                                    width="80"
                                                    height="80"
                                                />
                                            </Col>
                                        )
                                        : null
                                }
                                {
                                    this.state.teamRepresentative
                                        ? (
                                            <Col className="pl-4">
                                                <p>{this.getFullName()}</p>
                                                <p>{this.getPhoneHyperlink(this.state.teamRepresentative.phone_mobile, this.phoneFormats.teamRepresentative)}</p>
                                                <p>{this.getEmail(this.state.teamRepresentative)}</p>
                                            </Col>
                                        ) : null
                                }
                            </Row>
                        </div>
                    </ContentCard>
                    <ContentCard
                        className="mt-40 tagging-content-card"
                        divider={false}
                        headerTitle="Grief guidance material"
                        headerBtnText="View more"
                        headerSubComponent={(
                            <p className="guidance-sub-header">
                                Download any of the following documents to provide to clients as necessary.
                            </p>
                        )}
                    >
                        <CustomTable
                            className="guidance-table"
                            data={this.guidanceMaterial}
                            headers={['DOCUMENT NAME', 'FILE TYPE', 'DESCRIPTION', '']}
                        />
                    </ContentCard>
                </div>
            </div>
        );
    }
}

export default CustomerSupport;
